/**
 * ChaosTemplatePage - Chaos template management dashboard
 *
 * Surfaces the ChaosTemplateDashboard from @ferp/workflow-forms for admin/architect users.
 * Provides chaos document template management and conversion configuration.
 *
 * Route: /admin/chaos-templates
 */

import { Container, Title, Group, Badge, Text, ThemeIcon } from '@mantine/core';
import { IconFileImport } from '@tabler/icons-react';

import { ChaosTemplateDashboard } from '@ferp/workflow-forms';
import { useAuth } from '@/auth/AuthContext';

export function ChaosTemplatePage() {
  const { tenant } = useAuth();

  return (
    <Container size="xl" py="md">
      <Group justify="space-between" mb="lg">
        <Group gap="sm">
          <ThemeIcon size="lg" variant="light" color="dark">
            <IconFileImport size={20} />
          </ThemeIcon>
          <div>
            <Title order={3}>Chaos Templates</Title>
            <Text size="sm" c="dimmed">
              Chaos document template management and conversion configuration
            </Text>
          </div>
        </Group>
        {tenant && (
          <Badge variant="light" color="gray">
            {tenant.name}
          </Badge>
        )}
      </Group>

      <ChaosTemplateDashboard />
    </Container>
  );
}

export default ChaosTemplatePage;
